package com.shadowings.gero.domain.model

import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.changelog_1_11_10_item_2
import gero.composeapp.generated.resources.changelog_1_11_11_item_1
import gero.composeapp.generated.resources.changelog_1_11_11_item_2
import gero.composeapp.generated.resources.changelog_1_11_11_item_3
import gero.composeapp.generated.resources.changelog_1_11_7_item_1
import gero.composeapp.generated.resources.changelog_1_11_7_item_2
import gero.composeapp.generated.resources.changelog_1_11_7_item_3
import gero.composeapp.generated.resources.changelog_1_11_7_item_4
import gero.composeapp.generated.resources.changelog_1_11_7_item_5
import gero.composeapp.generated.resources.changelog_1_11_8_item_1
import gero.composeapp.generated.resources.changelog_1_11_8_item_2
import gero.composeapp.generated.resources.changelog_1_11_8_item_3
import gero.composeapp.generated.resources.changelog_1_11_8_item_4
import gero.composeapp.generated.resources.changelog_1_11_9_item_1
import gero.composeapp.generated.resources.changelog_1_11_9_item_2
import gero.composeapp.generated.resources.changelog_1_11_9_item_3
import gero.composeapp.generated.resources.changelog_1_11_9_item_4
import gero.composeapp.generated.resources.changelog_1_14_1_item_1
import gero.composeapp.generated.resources.changelog_1_14_2_item_1
import gero.composeapp.generated.resources.changelog_1_14_2_item_2
import gero.composeapp.generated.resources.changelog_1_14_2_item_3
import gero.composeapp.generated.resources.changelog_1_14_2_item_4
import gero.composeapp.generated.resources.changelog_15_0_0_item_1
import gero.composeapp.generated.resources.changelog_15_0_0_item_2
import gero.composeapp.generated.resources.changelog_15_0_0_item_3
import gero.composeapp.generated.resources.changelog_15_0_0_item_4
import gero.composeapp.generated.resources.changelog_15_0_0_item_5
import gero.composeapp.generated.resources.changelog_15_0_2_item_1
import gero.composeapp.generated.resources.changelog_15_0_2_item_2
import gero.composeapp.generated.resources.changelog_15_0_2_item_3
import gero.composeapp.generated.resources.changelog_15_0_2_item_4
import gero.composeapp.generated.resources.changelog_15_0_2_item_5
import gero.composeapp.generated.resources.changelog_16_0_0_item_1
import gero.composeapp.generated.resources.changelog_16_0_0_item_2
import gero.composeapp.generated.resources.changelog_16_0_0_item_3
import gero.composeapp.generated.resources.changelog_16_0_0_item_4
import gero.composeapp.generated.resources.changelog_16_0_1_item_1
import gero.composeapp.generated.resources.changelog_16_0_1_item_2
import gero.composeapp.generated.resources.changelog_16_0_1_item_3
import gero.composeapp.generated.resources.changelog_16_0_1_item_4
import gero.composeapp.generated.resources.changelog_15_0_3_item_1
import gero.composeapp.generated.resources.changelog_15_0_3_item_2
import gero.composeapp.generated.resources.changelog_15_0_3_item_3
import gero.composeapp.generated.resources.changelog_15_0_3_item_4
import gero.composeapp.generated.resources.changelog_15_0_3_item_5
import gero.composeapp.generated.resources.changelog_15_0_3_item_6
import gero.composeapp.generated.resources.changelog_15_0_3_item_7
import gero.composeapp.generated.resources.changelog_1_9_14_item_1
import gero.composeapp.generated.resources.changelog_1_9_14_item_2
import gero.composeapp.generated.resources.changelog_1_9_14_item_3
import gero.composeapp.generated.resources.changelog_1_9_14_item_4
import gero.composeapp.generated.resources.changelog_new_sounds
import org.jetbrains.compose.resources.StringResource

data class ChangelogEntry(
    val version: String,
    val items: List<StringResource>,
)

/**
 * Release notes, most recent first. The "what's new" popup (see `shouldShowChangelog`) only
 * ever shows [currentChangelogEntry] (the first item) once per version; the full list is browsable
 * from Settings via the changelog history screen. Add a new entry here (and its
 * `changelog_x_y_z_item_n` strings) for every release that should be announced to users — older
 * entries are kept, not replaced.
 */
val changelogEntries: List<ChangelogEntry> = listOf(
    ChangelogEntry(
        version = "16.0.1",
        items = listOf(
            Res.string.changelog_16_0_1_item_1,
            Res.string.changelog_16_0_1_item_2,
            Res.string.changelog_16_0_1_item_3,
            Res.string.changelog_16_0_1_item_4,
        )
    ),
    ChangelogEntry(
        version = "16.0.0",
        items = listOf(
            Res.string.changelog_16_0_0_item_1,
            Res.string.changelog_16_0_0_item_2,
            Res.string.changelog_16_0_0_item_3,
            Res.string.changelog_16_0_0_item_4,
        )
    ),
    ChangelogEntry(
        version = "15.0.3",
        items = listOf(
            Res.string.changelog_15_0_3_item_1,
            Res.string.changelog_15_0_3_item_2,
            Res.string.changelog_15_0_3_item_3,
            Res.string.changelog_15_0_3_item_4,
            Res.string.changelog_15_0_3_item_5,
            Res.string.changelog_15_0_3_item_6,
            Res.string.changelog_15_0_3_item_7,
        )
    ),
    ChangelogEntry(
        version = "15.0.2",
        items = listOf(
            Res.string.changelog_15_0_2_item_1,
            Res.string.changelog_15_0_2_item_2,
            Res.string.changelog_15_0_2_item_3,
            Res.string.changelog_15_0_2_item_4,
            Res.string.changelog_15_0_2_item_5,
        )
    ),
    ChangelogEntry(
        version = "15.0.0",
        items = listOf(
            Res.string.changelog_15_0_0_item_2,
            Res.string.changelog_15_0_0_item_3,
            Res.string.changelog_15_0_0_item_4,
            Res.string.changelog_15_0_0_item_5,
            Res.string.changelog_15_0_0_item_1,
        )
    ),
    ChangelogEntry(
        version = "1.14.2",
        items = listOf(
            Res.string.changelog_1_14_2_item_1,
            Res.string.changelog_1_14_2_item_2,
            Res.string.changelog_1_14_2_item_3,
            Res.string.changelog_1_14_2_item_4,
        )
    ),
    ChangelogEntry(
        version = "1.14.1",
        items = listOf(
            Res.string.changelog_1_14_1_item_1,
        )
    ),
    ChangelogEntry(
        version = "1.14.0",
        items = listOf(
            Res.string.changelog_1_11_11_item_2,
            Res.string.changelog_1_11_10_item_2,
            Res.string.changelog_1_11_11_item_1,
            Res.string.changelog_1_11_11_item_3,
        )
    ),
    ChangelogEntry(
        version = "1.11.9",
        items = listOf(
            Res.string.changelog_1_11_9_item_1,
            Res.string.changelog_1_11_9_item_2,
            Res.string.changelog_1_11_9_item_3,
            Res.string.changelog_1_11_9_item_4,
        )
    ),
    ChangelogEntry(
        version = "1.11.8",
        items = listOf(
            Res.string.changelog_1_11_8_item_1,
            Res.string.changelog_1_11_8_item_2,
            Res.string.changelog_1_11_8_item_3,
            Res.string.changelog_1_11_8_item_4,
        )
    ),
    ChangelogEntry(
        version = "1.11.7",
        items = listOf(
            Res.string.changelog_1_11_7_item_1,
            Res.string.changelog_1_11_7_item_2,
            Res.string.changelog_1_11_7_item_3,
            Res.string.changelog_1_11_7_item_4,
            Res.string.changelog_1_11_7_item_5,
        )
    ),
    ChangelogEntry(
        version = "1.11.0",
        items = listOf(
            Res.string.changelog_new_sounds,
            Res.string.changelog_1_9_14_item_1,
            Res.string.changelog_1_9_14_item_2,
            Res.string.changelog_1_9_14_item_3,
            Res.string.changelog_1_9_14_item_4,
        )
    )
)

val currentChangelogEntry: ChangelogEntry = changelogEntries.first()

/**
 * The changelog popup is shown only after the user has completed the intro tutorial, and
 * only once per version — except in debug builds, where it always shows (for easy testing).
 */
fun shouldShowChangelog(
    tutorialDone: Boolean?,
    lastSeenChangelogVersion: String,
    isDebugBuild: Boolean = false,
): Boolean {
    if (tutorialDone != true) return false
    if (isDebugBuild) return true
    return lastSeenChangelogVersion != currentChangelogEntry.version
}
